import React, {useEffect, useRef} from 'react'
import {createPortal} from "react-dom";

/**
 * Frage nach dem Anmelden über "Anmelden" auf der Startseite: in welchen Bereich gewechselt werden soll.
 * Schließen (X, Escape, Klick daneben) und "Auf der Startseite bleiben" lassen den Benutzer auf der Startseite.
 *
 * @param bereiche Liste von {id, icon, titel, text}
 * @param onWahl wird mit der id des gewählten Bereichs aufgerufen
 * @param onClose auf der Startseite bleiben
 */
export default function BereichWahlDialog({bereiche, onWahl, onClose}) {

    const ersterKnopfRef = useRef(null);

    useEffect(() => {
        // die Seite dahinter soll nicht mitscrollen
        const overflowVorher = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        if (ersterKnopfRef.current) {
            ersterKnopfRef.current.focus();
        }
        return () => {
            document.body.style.overflow = overflowVorher;
        };
    }, []);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                onClose();
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [onClose]);

    const dialog = <div className="dhpt-modal-hintergrund" onMouseDown={(event) => {
        // Klick neben den Dialog schließt ihn
        if (event.target === event.currentTarget) {
            onClose();
        }
    }}>
        <div className="dhpt-modal dhs-bereichwahl" role="dialog" aria-modal="true" aria-labelledby="dhs-bereichwahl-titel">
            <div className="dhpt-modal-kopf">
                <h2 id="dhs-bereichwahl-titel" className="dhpt-modal-titel"><i className="pi pi-compass" aria-hidden="true"/>In welchen Bereich möchtest du wechseln?</h2>
                <button type="button" className="dhpt-modal-schliessen" aria-label="Schließen" onClick={() => onClose()}>
                    <i className="pi pi-times" aria-hidden="true"/>
                </button>
            </div>
            <div className="dhs-bereichwahl-liste">
                {bereiche.map((bereich, index) =>
                    <button key={bereich.id} ref={index === 0 ? ersterKnopfRef : undefined} type="button"
                            className="dhs-bereichwahl-eintrag" onClick={() => onWahl(bereich.id)}>
                        <span className="dhs-bereichwahl-icon"><i className={bereich.icon} aria-hidden="true"/></span>
                        <span className="dhs-bereichwahl-text">
                            <strong>{bereich.titel}</strong>
                            <span>{bereich.text}</span>
                        </span>
                        <i className="pi pi-chevron-right dhs-bereichwahl-pfeil" aria-hidden="true"/>
                    </button>
                )}
            </div>
            <button type="button" className="dhpt-knopf-sekundaer dhs-bereichwahl-bleiben" onClick={() => onClose()}>
                <i className="pi pi-home" aria-hidden="true"/>Auf der Startseite bleiben
            </button>
        </div>
    </div>;

    // direkt in die Seite hängen (Farbvariablen aus .dhpt-seite), wie der LoginDialog
    const ziel = document.querySelector(".dhpt-seite");
    return ziel ? createPortal(dialog, ziel) : dialog;
}
